<template>
  <div class="login bg-main d-flex align-items-center p-3">
    <div class="mx-auto">
      <h1
        class="text-center 
        text-white mb-4"
        style="font-size: 4em; font-weight: 600 !important;"
      >
        CARE
      </h1>

      <b-alert
        :show="dismissCountDown"
        dismissible
        variant="primary"
        @dismissed="dismissCountDown = 0"
        class="my-2 px-3 text-left"
      >
        Check your email inbox...
      </b-alert>

      <!-- login form component -->
      <login-form @processLogin="login"></login-form>

      <!-- forgot password modal -->
      <b-modal
        v-model="modalResetPass"
        hide-header
        hide-footer
        @hidden="resetModal"
        centered
        size="sm"
      >
        <form v-on:submit.prevent="recoverPass">
          <b-form-group label="Enter your registered email" label-for="name-input">
            <b-form-input
              type="email"
              id="name-input"
              v-model="userEmail"
              placeholder="Email"
              required
            ></b-form-input>

            <b-form-text text-variant="danger" class="mt-3 ml-2">
              {{ errorMessage }}
            </b-form-text>

            <b-button type="submit" variant="warning" block :disabled="!userEmail">
              Send
            </b-button>
          </b-form-group>
        </form>
      </b-modal>
      <!-- /forgot password modal -->
    </div>
  </div>
</template>

<script>
import loginForm from '@/components/login/loginForm.vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  components: {
    loginForm,
  },
  data() {
    return {
      modalResetPass: false,
      userEmail: null,
      dismissSecs: 5,
      dismissCountDown: 0,
    };
  },
  computed: {
    ...mapGetters('user', ['errorMessage', 'getUserIsLogged']),
  },
  methods: {
    ...mapMutations('user', ['setUserIsLogged']),
    ...mapActions({ loginAction: 'user/login' }),
    ...mapActions('user', ['passwordRecovery']),
    resetModal() {
      this.userEmail = '';
    },
    recoverPass() {
      this.passwordRecovery(this.userEmail).then(() => {
        this.modalResetPass = false;
        this.dismissCountDown = this.dismissSecs;
      });
    },
    login(data) {
      if (this.requestSend) return;
      this.requestSend = true;
      this.loginAction(data).then((response) => {
        if (response.logged) {
          this.setUserIsLogged(true);
          this.$router.push('/');
        } else {
          this.requestSend = false;
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.getUserIsLogged) vm.$router.replace({ name: 'Home' });
    });
  },
};
</script>
